module.exports = __webpack_public_path__ + "media/images/pla/pla26-cce4a396dbd03e4cacaad43f7ec655ad.jpg";